<div class="bkg">

    <div class="header">
        הזמינו אירוע משותף ושחקו יחד!
    </div>

    <form [formGroup]="detailsForm" class="form row" (ngSubmit)="submitForm(formDirective)" #formDirective="ngForm">

        <mat-form-field appearance="fill" class="col-3">
            <mat-label class="asterisk-required">שם</mat-label>
            <input type="text" matInput formControlName="nvName">
            <mat-hint *ngIf="detailsForm?.controls.nvName.errors?.required && detailsForm?.controls.nvName.touched"
                class="text-danger">
                חובה להזין שם
            </mat-hint>

        </mat-form-field>

        <mat-form-field appearance="fill" class="col-4">
            <mat-label class="asterisk-required">מייל</mat-label>
            <input type="text" matInput formControlName="nvEmail">
            <mat-hint *ngIf="detailsForm?.controls.nvEmail.errors  && detailsForm?.controls.nvEmail.touched"
                class="text-danger">
                <span *ngIf="detailsForm?.controls.nvEmail.errors?.required">
                    חובה להזין כתובת מייל
                </span>
                <span *ngIf="detailsForm?.controls.nvEmail.errors?.pattern">
                    כתובת מייל לא תיקנית
                </span>
            </mat-hint>
        </mat-form-field>

        <mat-form-field appearance="fill" class="col-3">
            <mat-label class="asterisk-required">טלפון</mat-label>
            <input type="text" matInput formControlName="nvPhone">
            <mat-hint *ngIf="detailsForm?.controls.nvPhone.errors && detailsForm?.controls.nvPhone.touched"
                class="text-danger">
                <span *ngIf="detailsForm.controls.nvPhone.errors.required">
                    חובה להזין מספר טלפון
                </span>
                <span *ngIf="detailsForm.controls.nvPhone.errors.pattern">
                    מספר הטלפון חיב להכיל ספרות בלבד
                </span>
                <span
                    *ngIf="detailsForm.controls.nvPhone.errors.minlength || detailsForm.controls.nvPhone.errors.maxlength">
                    מספר טלפון חיב להכיל בין 9 ל 10 ספרות
                </span>
            </mat-hint>


        </mat-form-field>

        <button type="submit" class="submit-button">
            <span class="icon-new-telegram"></span>
        </button>

    </form>

</div>